export class RoutingUrl {
    public static PROPERTY_LISTING = '/property/property-listing';
    public static PROPERTY_SUBMENU = '/property/property-submenu';

    public static ANNOUNCEMENT_LISTING = '/news/announcement-listing';
    public static ANNOUNCEMENT_EDITOR_ADD = '/news/announcement/add';
    public static ANNOUNCEMENT_EDITOR_EDIT = '/news/announcement/edit';
    public static ANNOUNCEMENT_VIEW = '/news/announcement/view';

    public static TODO_LISTING = '/todo/todo-listing';
    public static BOOKING_DETAILS = '/todo/booking-details';
    public static BRAND_ALLOCATION_DETAILS = '/todo/brand-allocation-details';
    public static RENTAL_CONTRACT_DETAILS = '/todo/rental-contract-details';
    public static LEASING_POLICY_APPROVAL_DETAILS = '/todo/leasing-policy-approval-details';
    public static RENOVATION_ADMINISTRATION_DETAILS = '/todo/renovation-administration-details';
    public static NOTIFICATION_LISTING = '/notifications/notification-listing';
    public static EVENT_MANAGEMENT_DETAILS = '/todo/event-management-details';
    public static SERVICEREQUEST_LISTING = '/service-request/service-request-listing';
    public static SERVICEREQUEST_ADD = '/service-request/add-service-request';
    public static SERVICEREQUEST_ACTIVITIES = '/service-request/service-request-activities';
    public static SERVICEREQUEST_DETAILS = '/service-request/service-request-details';
    public static SERVICEREQUEST_QUOTATION = '/service-request/service-request-quotation';
    public static SERVICEREQUEST_SUBHEADER = '/service-request/service-request-subheader';

    public static LISTING_TEMPLATE = '/template/listing-template';

    public static LOGIN = '/authentication/login';
    public static FORGOT_PASSWORD = '/authentication/forgot';
    public static HOME = '/';

    public static TENANT_SALES_COLLECTION_LISTING = '/tenant-sales-collection/tenant-sales-collection-listing';
    public static TENANT_SALES_SUBMISSION_LISTING = '/tenant-sales-collection/tenant-sales-submission-listing';
    public static TENANT_SALES_SUBMISSION_DETAILS = '/tenant-sales-collection/tenant-sales-submission-details';
    public static CREATE_TENANT_SALES = '/tenant-sales-collection/create-tenant-sales';
    public static EDIT_TENANT_SALES = '/tenant-sales-collection/create-tenant-sales/edit-draft';
    public static MONTHLY_SALES_SUBMISSION_LISTING = '/tenant-sales-collection/monthly-sales-submission-listing';
    public static DAILY_COMPLETED_SALES_LISTING = '/tenant-sales-collection/daily-completed-sales-listing';
    public static DAILY_COMPLETED_SALES_DETAILS = '/tenant-sales-collection/daily-completed-sales-details';

    public static METER_TYPE_LISTING = '/meter/meter-type-listing';
    public static ROUTINE_INSPECTION_LISTING = '/routine-inspection/routine-inspection-listing';
}
